import HeroSequence from "./HeroSequence";

/**
 * HERO MEDIA — swappable cinematic transformation→metamorphosis visual.
 *
 * To drop in a real generated video later, set HERO_VIDEO_SOURCES below.
 * The layout, sizing and fallbacks stay identical — no other changes needed.
 * Requirements already wired: autoplay, loop, muted, playsInline, poster,
 * prefers-reduced-motion, responsive/mobile treatment, lazy decode.
 *
 * Example:
 *   const HERO_VIDEO_SOURCES = [
 *     { src: "/hero/regera-metamorphosis.webm", type: "video/webm" },
 *     { src: "/hero/regera-metamorphosis.mp4",  type: "video/mp4" },
 *   ];
 *   const HERO_POSTER = "/hero/regera-metamorphosis-poster.jpg";
 */
const HERO_VIDEO_SOURCES = []; // <-- add sources here to use a real video
const HERO_POSTER = "/regera-mark.png";

export default function HeroMedia({ mobile = false }) {
  const hasVideo = HERO_VIDEO_SOURCES.length > 0;

  if (hasVideo) {
    return (
      <div className="relative h-full w-full" data-testid="hero-media-video">
        <video
          className="h-full w-full object-cover"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster={HERO_POSTER}
          aria-label="REGERA — from transformation to metamorphosis"
        >
          {HERO_VIDEO_SOURCES.map((s) => (
            <source key={s.src} src={s.src} type={s.type} />
          ))}
        </video>
      </div>
    );
  }

  // Fallback / default: original coded cinematic sequence.
  return <HeroSequence mobile={mobile} />;
}
